import { FormAggregatedResultElementProps } from "@/components/form-result/aggregated-result/components/types.ts";
import { Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const FormAggregatedResultTextElement = ({ element }: FormAggregatedResultElementProps) => {
  const { t } = useTranslation();
  const textElementSettings = element.text_settings;
  if (!textElementSettings) return null;

  return (
    <>
      <Title
        header={textElementSettings.title || t("surveys:question_type_text_full")}
        size={"sm"}
        className={textElementSettings.title ? "" : "text-secondary"}
      />
    </>
  );
};
